import { render, staticRenderFns } from "./addIncentives.vue?vue&type=template&id=13bb1142&scoped=true&"
import script from "./addIncentives.vue?vue&type=script&lang=js&"
export * from "./addIncentives.vue?vue&type=script&lang=js&"
import style0 from "./addIncentives.vue?vue&type=style&index=0&id=13bb1142&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bb1142",
  null
  
)

export default component.exports